import { render } from "./HospitalPage.vue?vue&type=template&id=8a28fa92&ts=true"
import script from "./HospitalPage.vue?vue&type=script&lang=ts"
export * from "./HospitalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__